import actions from "@/store/modules/custom-agency-pay-rates/actions";
import mutations from "@/store/modules/custom-agency-pay-rates/mutations";
import getters from "@/store/modules/custom-agency-pay-rates/getters";

export const CUSTOM_AGENCY_FEE_NAMESPACE = "customAgencyPayRates";

const initialState = {
  isFetchingAggregatedCustomAgencyFee: false,
  isFetchingGroupedCustomAgencyFee: false,
  aggregatedCustomAgencyFees: [
    /**
     * {
     * applicationId: 1,
     * agencyId: 1,
     * preAwr: 0,
     * postAwr: 0,
     * }
     */
  ],
  groupedCustomAgencyFees: [
    /**
         * {
            "agency_name": "Brevan Wallis",
            "total_cost": "23.00",
            "applicants": [
                {
                    "fullname": "Test 1 test",
                    "total_cost": "25.00"
                }
            ]
        }
        */
  ]
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
